
$(document).ready(function() {
  

    let cartContent = {};
    
    function updatePartial(){
        $.ajax({
            url: '/cart.js',
            dataType: 'json'
        }).done(function(data){
            var newCount = data.item_count;
            var label = newCount > 1 ? ' items' : ' item';
            $('.cart-items-count').html(newCount+ label);
            $('.cs-count').html(newCount);
            var newPrice =  data.total_price / 100  ;
            $('.cart__subtotal').html('$'+newPrice);
            var freeShippingN = parseInt(data.total_price) ;
            showPromotionfreeShipping(freeShippingN);

            var cartCheckout = document.querySelector('.cart-checkout');
            cartCheckout.value = "Check Out " + Shopify.formatMoney(data.total_price);
        });
    }

    function showPromotionfreeShipping(price){
        if (price < 5000) {
            var pendingP = 5000 - price;
            var pprice = pendingP / 100;
            $('.progress-shipping').show();
            $('.two-day-free').hide();
            $('.progress-shipping progress').val((price / 100).toFixed(0));
            $('.progress-shipping .important.price').html('$'+pprice.toFixed(2));
        }  else {
            $('.progress-shipping').hide();
            $('.two-day-free').show();
        }
    }
  
  
      function addToCart(id,qty) {
        var data = {
            "id": id,
            "quantity": parseInt(qty)
        }
        
 
        


            
        
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() {
              
      
    		window.location.href = "/cart";

        
  

              
        		
            }
        });
    }


    function loadRecommedProducts(cartContent){
      	let allRProducts = [];
      
        var $opts = {
            dots: false,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
          responsive: [{
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2
            }
          }, 
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }, 
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: false,
              dots: true
            }
          }]
        }


           $.ajax({
                url: '/recommendations/products.json?product_id='+cartContent[0].product_id+'&limit=10',
                dataType: 'json',
              complete: function (data) {
     	   $('.cs-add-to-cart-cr').on('click',function(e) {
               		 e.preventDefault();
                  e.stopPropagation();

               		 let id = $(this).attr('data-id');
					 let data = {
                        "id": id,
                        "quantity": parseInt(1)
                    };
              
             
      
               

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() {
               window.location.href = "/cart";
            }
       
        });
        
        
                });
     }
    
            }).done(function(data){
             
             	let $html = '';
             
              //  $('.products-carousel').slick('slickRemove');
             
               data.products.forEach(function(element){
                    $html = '<div>';
                 	$html += '<a href="'+element.url+'"><img src="'+element.featured_image+'" /> </a>';
                    $html += '<h3><a href="'+element.url+'">'+element.title+'</a></h3>';
                 	$html += '<span class="price-pro-carousel">$'+ (element.price / 100 ).toFixed(2)+' </span>';
                 	$html += '<div class="grid-view-item__btn text-center"><a href="#" class="cs-add-to-cart-cr"    data-id="'+element.variants[0]["id"]+'"> Add to cart </a></div>';
                    $html += '</div>';
                 	$('.products-carousel').append($html);
                 
               });
             
  				$('.products-carousel').slick($opts);
    
             
           
            }); 

 
      
  

       

    }

    function loadCartcontent(){
        $.ajax({
            url: '/cart.js',
            dataType: 'json'
        }).done(function(data){
            cartContent = data.items;
            loadRecommedProducts(cartContent);
            var freeShippingN = parseInt(data.total_price) ;
            showPromotionfreeShipping(freeShippingN)
        });
    }

    loadCartcontent();


  

    $('.cart__remove').on('click', function(e){

        e.preventDefault();
        var id = $(this).attr('data-id');
        var titleProduct = $(this).parents('.product-item').find('.list-view-item__title').text();
        var jqxhr = $.post('/cart/update.js', 'updates['+id+']=0');
        var that= this;

        jqxhr.complete(function() {
            $(that).parents('.product-item').remove();
            $('#cart-products-list').prepend(' <div id="product-'+id+'" class="product-deleted" data-id="'+id+'">"'+titleProduct+'" has been removed. <a class="undo" href="#">Undo</a>. </div>');
            setTimeout(function() {
                $('#cart-products-list #product-'+id).remove();
            }, 8000);

            updatePartial();

            $('#cart-products-list .undo').on('click', function(e){
                e.preventDefault();
                $(this).parent().remove();
                var id = $(this).parent().attr('data-id');
                var jqxhr = $.post('/cart/update.js', 'updates['+id+']=1');

                jqxhr.complete(function() {

                    location.reload();
                });

            });
        });

        return false;
    });


   // Shipping Calculator
    const newYears = '01-01-2022';          /* January 1 – New Year's Day */
    const martinLK = '01-18-2021';          /* January 18 – Martin Luther King, Jr. Day */
    const presidentsDay = '02-15-2022';     /* February 15 – President's Day */
    const memorialDay = '05-31-2022';       /* May 31 – Memorial Day */
    const indeDay = '07-04-2022';           /* July 4 – Independence Day */
    const indeDayTwo = '07-05-2022';        /* July 5 – Independence Day (observed) */
    const laborDay = '09-06-2022';          /* September 6 – Labor Day */
    const columbusDay = '10-11-2022';       /* October 11 – Columbus Day */
    const veteransDay = '11-11-2022';       /* November 11 – Veterans Day */
    const thanksgivingDay = '11-25-2022';   /* November 25 – Thanksgiving Day */
    const christmasDay = '12-24-2022';      /* December 24 – Christmas Day (observed) */
    const christmasDayTwo = '12-25-2022';   /* December 25 – Christmas Day */
    const newYearsDay = '12-31-2022';       /* December 31 – New Year's Day (observed) */

    moment.updateLocale('us', {
        holidays: [newYears, martinLK,presidentsDay,memorialDay, indeDay,indeDayTwo,laborDay,columbusDay,veteransDay,thanksgivingDay,christmasDay, christmasDayTwo,newYearsDay],
        holidayFormat: 'MM-DD-YYYY',
        workingWeekdays: [1, 2, 3, 4, 5]
    });

    let now =  moment( );
    let standardDate = moment(now, 'DD-MM-YYYY').businessAdd(3).format('MMM DD') + " - " + moment(now, 'DD-MM-YYYY').businessAdd(5).format('MMM DD');
    let twoDay = moment(now, 'DD-MM-YYYY').businessAdd(2).format('MMM DD') + " - " + moment(now, 'DD-MM-YYYY').businessAdd(3).format('MMM DD');
  	let fourDay = moment(now, 'DD-MM-YYYY').businessAdd(4).format('MMM DD');
    let oneDay = moment(now, 'DD-MM-YYYY').businessAdd(1).format('MMM DD');

    $('.methods .standard-date').html(standardDate);
    $('.methods .two-date').html(twoDay);
    $('.methods .four-date').html(fourDay);
    $('.methods .one-date').html(oneDay);
  
   let ssTime, ennTime, duration, hours, minutes, nextBusinessDayT, nextEndBusinessT, durationNexET, nexWeekDay;

  function countDown(){
    now = moment();
    if (now.isBusinessDay()) {
       ssTime    = moment("12:00:00 am", "HH:mm:ss a");
       ennTime   = moment("04:00:00 pm", "HH:mm:ss a"); 
      if (now.weekday() === 5) {
          ssTime    = moment("12:00:00 am", "HH:mm:ss a");
          ennTime   = moment("01:00:00 pm", "HH:mm:ss a");
      }
      
      if (now.weekday() === 5 && now.isAfter(ennTime) ) {
        nextBusinessDayT = moment().nextBusinessDay().format('DD-MM-YYYY');
        nextEndBusinessT = moment(nextBusinessDayT+" 04:00:00 pm", "DD-MM-YYYY HH:mm:ss a");
        durationNexET = moment.duration(nextEndBusinessT.diff(now));
        $('.time-left').html('within the next '+(durationNexET.days() )+' day '+durationNexET.hours()+' hours and '+durationNexET.minutes()+' minutes');
        
        
        standardDate = moment(now, 'DD-MM-YYYY').businessAdd(4).format('MMM DD') + " - " + moment(now, 'DD-MM-YYYY').businessAdd(6).format('MMM DD');
     	twoDay = moment(now, 'DD-MM-YYYY').businessAdd(2).format('MMM DD') + " - " + moment(now, 'DD-MM-YYYY').businessAdd(3).format('MMM DD');
        fourDay = moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(4).format('MMM DD');
     	oneDay = moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(1).format('MMM DD');

        $('.methods .standard-date').html(standardDate);
        $('.methods .two-date').html(twoDay);
        $('.methods .four-date').html(fourDay);
        $('.methods .one-date').html(oneDay);
  
        
      } else if (now.isAfter(ennTime)) {
        nextBusinessDayT = moment().nextBusinessDay().format('DD-MM-YYYY');
        nextEndBusinessT = moment(nextBusinessDayT+" 04:00:00 pm", "DD-MM-YYYY HH:mm:ss a");
        durationNexET = moment.duration(nextEndBusinessT.diff(now));
        
        $('.time-left').html('in the next '+durationNexET.hours()+' hours and '+durationNexET.minutes()+' minutes');
        
        
        standardDate = moment(now, 'DD-MM-YYYY').businessAdd(4).format('MMM DD') + " - " + moment(now, 'DD-MM-YYYY').businessAdd(6).format('MMM DD');
     	twoDay = moment(now, 'DD-MM-YYYY').businessAdd(3).format('MMM DD') + " - " + moment(now, 'DD-MM-YYYY').businessAdd(4).format('MMM DD');
        fourDay = moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(4).format('MMM DD');
     	oneDay = moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(1).format('MMM DD');

        $('.methods .standard-date').html(standardDate);
        $('.methods .two-date').html(twoDay);
        $('.methods .four-date').html(fourDay);
        $('.methods .one-date').html(oneDay);
        
        
        
      }   else  if (now.isBetween(ssTime, ennTime)) {
           duration = moment.duration(ennTime.diff(now));
           hours = duration.hours(); //hours instead of asHours
           minutes = duration.minutes(); //minutes instead of asMinutes
          $('.time-left').html('in the next '+hours+' hours and '+minutes+' minutes');
      } else {
        nexWeekDay = moment().nextBusinessDay().weekday();
        nextBusinessDayT = moment().nextBusinessDay().format('DD-MM-YYYY');
        nextEndBusinessT = moment(nextBusinessDayT+" 04:00:00 pm", "DD-MM-YYYY HH:mm:ss a");
        if(nexWeekDay === 1) {
           nextEndBusinessT = moment(nextBusinessDayT+" 04:00:00 pm", "DD-MM-YYYY HH:mm:ss a");
           durationNexET = moment.duration(nextEndBusinessT.diff(now));
          $('.time-left').html('within the next '+durationNexET.days()+' day '+durationNexET.hours()+' hours and '+durationNexET.minutes()+' minutes');
        }else if (nexWeekDay === 5) {
          nextEndBusinessT = moment(nextBusinessDayT+" 01:00:00 pm", "DD-MM-YYYY HH:mm:ss a");
           durationNexET = moment.duration(nextEndBusinessT.diff(now));
          $('.time-left').html('in the next '+durationNexET.hours()+' hours and '+durationNexET.minutes()+' minutes');
        } 
        
      }
   } else {

     nextBusinessDayT = moment().nextBusinessDay().format('DD-MM-YYYY');
     nextEndBusinessT = moment(nextBusinessDayT+" 04:00:00 pm", "DD-MM-YYYY HH:mm:ss a");
     duration = moment.duration(nextEndBusinessT.diff(now));
     hours = duration.hours(); 
     minutes = duration.minutes(); 
     $('.time-left').html('wthin the next '+duration.days()+' days '+hours+' hours and '+minutes+' minutes');
        
     standardDate = moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(3).format('MMM DD') + " - " + moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(5).format('MMM DD');
     twoDay = moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(2).format('MMM DD') + " - " + moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(3).format('MMM DD');
     fourDay = moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(4).format('MMM DD');
     oneDay = moment(nextBusinessDayT, 'DD-MM-YYYY').businessAdd(1).format('MMM DD');

    $('.methods .standard-date').html(standardDate);
    $('.methods .two-date').html(twoDay);
    $('.methods .four-date').html(fourDay);
    $('.methods .one-date').html(oneDay);
     
   }
  }
  countDown();
  setInterval(function(){
    countDown()
  }, 1000);
});
